import type { RootState } from '@shared/redux/root-state';

export const channelFormDraftsSelectors = {
  selectDraftByKey: (key: string) => (state: RootState) => state.channelFormDrafts.byKey[key]?.values,
  selectUpdatedAtByKey: (key: string) => (state: RootState) =>
    state.channelFormDrafts.byKey[key]?.updatedAt,
};
